jQuery(document).ready( function ($) {

  var user = '<a href="/my-account" class="my-account et_pb_menu__icon" aria-label="My Account"> </a>';

  $(user).insertBefore('.top-nav.mobile .et_pb_menu__cart-button');

  $('.cart-count').contents().clone().insertAfter('.et_pb_menu__icon.et_pb_menu__cart-button').wrap('<span class="cart-count"></span>');

  $('#menu-my-account-navigation ul li a').on('click', function(){
    $(this).parent().removeClass('active').addClass('active');
  }); 

  // Add active class to My Account nav links
  const pgurl = window.location.href;
  $('ul#menu-my-account-navigation li a').each( function(){
    if ( $(this).attr("href") == pgurl){
      $(this).parent("li").addClass("active");
    }
  });



  // FAQs accordion
  let $open = $();
	$(".head").on("click", function (e) {
		e.preventDefault();

		$open.slideUp(500);
		$open = $(this).closest("li").find(".content");
		$open.not(":animated").slideToggle(150);

		$(this).toggleClass("clicked unclick");

		$(this).parent().siblings().find("a").removeClass("clicked");
	});

 
}); 

// Run after the DOM has loaded
// This is for centering the plan card when there is one being displayed
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".four-column");
  if (!container) return;

  // Get all direct child divs of the container
  const childDivs = Array.from(container.children);

  // Count how many are visible (display not 'none')
  const visibleDivs = childDivs.filter(div => {
    return window.getComputedStyle(div).display !== "none";
  });

  // If only one visible, add class to container
  if (visibleDivs.length === 1) {
    container.classList.add("single-column");
  } else {
    container.classList.remove("single-column");
  }
});
